<script setup lang="ts">
import TheIcon from '@/components/atoms/TheIcon/TheIcon.vue'
import { computed } from 'vue'
const props = defineProps<{
    icon: string
    text: string
    type?: string
}>()
const parsedString = computed(() => {
    let text = props.text

    const regExEmail = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi
    const regExPhone = /\+?[0-9 ]{8,}/gi
    const regExDomain =
        /(^|\s)(https?:\/\/(www\.)?|www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\/[a-zA-Z0-9-._~!$&'()*+,;=:@\/]*)*\/?(?=$|\s|[^\w])/g

    text = text.replace(regExDomain, (domain) => {
        return `<a href="${domain}" target='_blank'>${domain}</a>`
    })
    text = text.replace(regExEmail, (email) => {
        return `<a href="mailto:${email}">${email}</a>`
    })
    text = text.replace(regExPhone, (phoneNumber) => {
        return `<a href="tel:${phoneNumber}">${phoneNumber}</a>`
    })

    return text
})
</script>

<template>
    <div
        class="icon-and-text"
        :class="`icon-and-text--${type}`"
    >
        <div class="d-flex align-items-center">
            <TheIcon
                :name="icon"
                class="icon-and-text__icon"
            />
            <span
                v-html="parsedString"
                class="icon-and-text__text"
            ></span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.icon-and-text {
    &--secondary {
        opacity: 0.6;

        .icon-and-text__text {
            font-style: italic;
        }
    }

    &__icon {
        font-size: rem(50);
    }

    &__text {
        font-size: rem(20);
        font-weight: 400;
        margin-left: rem(12);
        white-space: pre-line;
    
        //:deep added due to scoped styling which prevents styling on html added with v-html
        :deep(a:nth-of-type(2)) {
            margin-left: rem(8);
        }
    }
}
</style>
